import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { LightThemeColors } from '../../Themes';

import styles from './Dot.Styles';

function Dot({ theme, index, activeIndex, isEditMode }) {
  return index === activeIndex ? (
    <View
      style={styles.outerDotStyle(theme)}
      testID={FoundationTestKeys.horizontalStepperOuterDotView}
    >
      <View
        style={styles.innerDotStyle(theme)}
        testID={FoundationTestKeys.horizontalStepperInnerDotView}
      />
    </View>
  ) : index < activeIndex || isEditMode ? (
    <View
      style={styles.redDotStyle(theme)}
      testID={FoundationTestKeys.horizontalStepperRedDotView}
    />
  ) : (
    <View
      style={styles.greyDotStyle(theme)}
      testID={FoundationTestKeys.horizontalStepperGreyDotView}
    />
  );
}

Dot.defaultProps = {
  theme: LightThemeColors,
  isEditMode: false,
};

Dot.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  index: PropTypes.number,
  activeIndex: PropTypes.number,
  isEditMode: PropTypes.bool,
};

export default Dot;
